import { BASE_URL, request } from "./api";
import type {
  Amortization,
  AmortizationRequestDto,
  AmortizationUpdateRequestDto,
  PaymentStatusUpdateDto,
  PaymentStatusUpdateWithDetailsDto,
} from "./types";

export type { Amortization, PaymentStatusUpdateWithDetailsDto };

// GET /api/Amortization
export const getAmortizations = async (): Promise<Amortization[]> => {
  return request<Amortization[]>(`${BASE_URL}/api/Amortization`, {
    method: "GET",
  });
};

// POST /api/Amortization
export const createAmortization = async (
  data: AmortizationRequestDto
): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Amortization`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: data
  });
};

// GET /api/Amortization/{id}
export const getAmortizationById = async (
  id: number
): Promise<Amortization> => {
  return request<Amortization>(`${BASE_URL}/api/Amortization/${id}`, {
    method: "GET",
  });
};

// PUT /api/Amortization/{id}
export const updateAmortization = async (
  id: number,
  data: AmortizationUpdateRequestDto
): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Amortization/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: data
  });
};

// DELETE /api/Amortization/{id}
export const deleteAmortization = async (id: number): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Amortization/${id}`, {
    method: "DELETE",
  });
};

// PUT /api/Amortization/{id}/payment-status - New webhook endpoint
export const updateAmortizationPaymentStatus = async (
  id: number,
  data: PaymentStatusUpdateDto
): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Amortization/${id}/payment-status`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: data
  });
};

// PUT /api/Amortization/{id}/payment-status - Extended version with payment details
export const updateAmortizationPaymentStatusWithDetails = async (
  id: number,
  data: PaymentStatusUpdateWithDetailsDto
): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Amortization/${id}/payment-status`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: data
  });
};

// GET /api/Amortization/patient/{patientId}
export const fetchAmortizationsByPatient = async (
  patientId: number
): Promise<Amortization[]> => {
  return request<Amortization[]>(
    `${BASE_URL}/api/Amortization/patient/${patientId}`,
    { method: "GET" }
  );
};

// GET /api/Amortization filtered by plan
export const fetchAmortizationsByPlan = async (
  treatmentPlanId: number
): Promise<Amortization[]> => {
  const amortizations = await request<Amortization[]>(
    `${BASE_URL}/api/Amortization`,
    { method: "GET" }
  );
  return amortizations.filter((a) => a.treatmentPlanId === treatmentPlanId);
};